function handleFormError(errorsData) {
    let rules = [];

    for (var errorData in errorsData) {
        if(Object.prototype.hasOwnProperty.call(errorsData, errorData)) {
            for (var errorDataSub in errorsData['' + errorData]) {
                if (Object.prototype.hasOwnProperty.call(errorsData['' + errorData], errorDataSub)) {
                    if(errorDataSub === "0") {
                        rules.push(
                            {
                                errorData,
                                errorDataSub
                            }
                        );
                    }
                }
            }
        }
    }

    return setRules(rules, errorsData);
}

function setRules(rules, errorsData) {
    let rulesData = [];

    for(const rule in rules) {
        let errorType = rules[rule]["errorDataSub"];
        let errorArg = rules[rule]["errorData"];


        if(errorArg === "email") {
            rulesData[errorArg] = [
                v => /.+@.+\..+/.test(v) || errorsData[errorArg][errorType],
                v => !!v || errorsData[errorArg][errorType]
            ];
        } else if(errorArg === "short_description") {
            rulesData[errorArg] = [
                v => !!v || errorsData[errorArg][errorType],
                v => (v || '').length <= 500 || errorsData[errorArg][errorType]
            ];
        } else if(errorArg === "long_description"){
            rulesData[errorArg] = [
                v => !!v || errorsData[errorArg][errorType],
                v => (v || '').length <= 5000 || errorsData[errorArg][errorType]
            ];

        }
        else {
            rulesData[errorArg] = [
                v => !!v || errorsData[errorArg][errorType],
            ];
        }
    }
    return rulesData;
}

export default handleFormError;